module.exports = __webpack_public_path__ + "img/x2.311c2157.jpg";